import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getAdditionalProps } from 'apps/studio/components/settings/inputs'
import { useInactiveUpdate } from 'apps/studio/lib/hooks/useInactiveUpdate'

export const SettingsNumberInput = ({
  property,
  label,
  id,
  data,
  update,
  min: minValue,
  max: maxValue,
  validation = false,
  additionalProps = {},
  IconLeading,
  errorMsgHandler = () => {},
  labelAbove,
}) => {
  const calculatedProps = {
    min: minValue,
    max: maxValue,
    ...getAdditionalProps(additionalProps, data),
  }
  const dispatch = useDispatch()
  const { [property]: value } = data
  const makeUpdate = updatedValue =>
    dispatch(update({ [property]: updatedValue }))
  const validate = updatedValue => {
    if (typeof validation === 'function') {
      return validation({ ...data, [property]: updatedValue })
    }
    return false
  }

  const { errors, ...attributes } = useInactiveUpdate(
    value,
    validate,
    makeUpdate,
    { ...calculatedProps }
  )
  useEffect(() => {
    errorMsgHandler(errors)
  }, [errors, errorMsgHandler])

  const className = `gcds--input-fields input--secondary input--small settings-number-input-wrapper${labelAbove ? ' label--above' : ''}`

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="input-fields__label">
          {label}
        </label>
      )}
      <div className="input-fields--wrapper">
        {IconLeading && (
          <div className="input-fields__icon-container icon--leading">
            <IconLeading />
          </div>
        )}
        <input
          id={id}
          type="number"
          className="input-fields__input"
          {...attributes}
          {...calculatedProps}
        />
        {errors && (
          <div className="field-error--wrap">
            <span className="field-error--message">{errors}</span>
          </div>
        )}
      </div>
    </div>
  )
}
